import { Box, Center, Heading, Icon } from "@chakra-ui/react";
import { TbAlertTriangle } from "react-icons/tb";

export function NotFoundPage() {
    return (
        <Box bg="white" boxShadow="xs" borderRadius="md" p="sectionGap" mb="sectionGap">
            <Center mb="4"><Icon as={TbAlertTriangle} boxSize="24" color="red.400" mx="auto" /></Center>
            <Heading as="h1" textAlign="center" size="lg" mb="6">Page Not Found</Heading>
            <Heading as="h2" textAlign="center" size="md">The page you are looking for does not exist.</Heading>
        </Box>
    )
}
